/** @jsxImportSource @emotion/react */
import { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { useTheme } from '@mui/material/styles';

export type ContentAreaPropsT = {
  side?: keyof typeof sidePaddings;
  top?: keyof typeof topBottomPaddings;
  bottom?: keyof typeof topBottomPaddings;
};

const sidePaddings = {
  none: 0,
  narrow: 8,
  medium: 16,
  wide: 24,
};

const topBottomPaddings = {
  none: 0,
  narrow: 8,
  medium: 16,
  wide: 24,
  veryWide: 64,
};

const baseCss = (color) => css`
  background-color: ${color};
  flex: 1; /* root 가 flex여서 최대로 꽉 차게 하기 */
  display: flex;
  flex-direction: column;
  align-content: flex-start;

  /* 하위에 pull to refresh 컴포넌트를 사용할 때를 위한 css */
  & > div.ptr,
  & > div.ptr > div.ptr__children {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

const sideCss = (side: keyof typeof sidePaddings) => css`
  padding-left: ${sidePaddings[side]}px;
  padding-right: ${sidePaddings[side]}px;
`;

const topCss = (top: keyof typeof topBottomPaddings) => css`
  padding-top: ${topBottomPaddings[top]}px;
`;

const bottomCss = (top: keyof typeof topBottomPaddings) => css`
  padding-bottom: ${topBottomPaddings[top]}px;
`;

function ContentArea({
  side,
  top,
  bottom,
  children,
}: PropsWithChildren<ContentAreaPropsT>) {
  const { palette } = useTheme();

  return (
    <div
      css={[
        baseCss(palette.background.paper),
        sideCss(side || 'none'),
        topCss(top || 'none'),
        bottomCss(bottom || top || 'none'),
      ]}
    >
      {children}
    </div>
  );
}
export default ContentArea;
